const STOP_WORDS = new Set([
    // English
    "the", "a", "an", "and", "or", "but", "in", "on", "at", "to", "for", "of", "with", "by", "from",
    "is", "it", "its", "this", "that", "are", "was", "were", "be", "been", "being", "have", "has", "had",
    "do", "does", "did", "will", "would", "could", "should", "may", "might", "can", "shall", "not", "no",
    "so", "if", "then", "than", "too", "very", "just", "about", "up", "out", "all", "also", "as", "more",
    "most", "some", "any", "each", "every", "both", "few", "many", "much", "own", "other", "such", "into",
    "over", "after", "before", "between", "under", "through", "during", "without", "again", "there", "here",
    "who", "what", "when", "where", "why", "how", "which", "their", "them", "they", "we", "our", "you",
    "your", "my", "me", "he", "she", "him", "her", "i", "like", "use", "get", "make", "need", "want",
    "think", "know", "people", "would", "really", "thing", "things", "way", "able", "lot", "using",
    // Spanish
    "el", "la", "los", "las", "un", "una", "unos", "unas", "de", "del", "al", "en", "con", "por", "para",
    "es", "son", "está", "están", "ser", "hay", "que", "se", "no", "más", "pero", "como", "su", "sus",
    "yo", "tú", "él", "ella", "nos", "les", "lo", "ya", "muy", "todo", "esta", "este", "eso", "esa",
]);

export function buildWordFrequency(texts) {
    const freq = {};
    for (const text of texts) {
        if (!text) continue;
        const words = text.toLowerCase().replace(/[^a-záéíóúñü\s]/gi, "").split(/\s+/);
        for (const w of words) {
            if (w.length < 3 || STOP_WORDS.has(w)) continue;
            freq[w] = (freq[w] || 0) + 1;
        }
    }
    return Object.entries(freq)
        .map(([word, count]) => ({ word, count }))
        .sort((a, b) => b.count - a.count);
}

export function extractPersonas(responses) {
    const veryDisappointed = responses.filter((r) => r.disappointment === "very_disappointed");
    return buildWordFrequency(veryDisappointed.map((r) => r.benefitPersona)).slice(0, 15);
}

export function computeSegmentedScore(responses, keyword) {
    if (!keyword) return null;
    const filtered = responses.filter((r) => r.benefitPersona?.toLowerCase().includes(keyword.toLowerCase()));
    if (filtered.length === 0) return null;
    const vd = filtered.filter((r) => r.disappointment === "very_disappointed").length;
    return { score: Math.round((vd / filtered.length) * 1000) / 10, total: filtered.length, vd };
}

export function getScoreColor(score) {
    if (score >= 40) return "text-green-600";
    if (score >= 20) return "text-amber-500";
    return "text-red-500";
}

export function getScoreBg(score) {
    if (score >= 40) return "bg-green-50 border-green-200";
    if (score >= 20) return "bg-amber-50 border-amber-200";
    return "bg-red-50 border-red-200";
}
